<template>
  <div
    class="w-full px-4 py-2 flex tablet-h:rounded-[10px] tablet-h:p-1.5 tablet-h:pr-2.5"
    :class="classes"
  >
    <div class="mr-[9px] size-11 shrink-0 p-0.5">
      <div
        class="flex size-full items-center justify-center rounded-full"
        :class="isSuccess ? 'bg-green-700/10' : 'bg-red-700/10'"
      >
        <component
          :is="isSuccess ? VerifiedDefaultIcon : AlertIcon"
          class="size-5"
          :class="isSuccess ? 'text-green-700' : 'text-red-700'"
        />
      </div>
    </div>
    <div class="text-[14px] leading-[19px] text-gray-800 -mt-1 flex flex-col">
      <div class="mb-[3px]">{{ copy }}</div>
      <div class="text-[12px] leading-[18px] opacity-60">
        {{ formatDistanceToNowStrict(props.notification.timestamp) }} ago
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  NotificationType,
  type Notification,
} from '@/shared/graphql/legacy/generated'
import { AlertIcon, VerifiedDefaultIcon } from '@dacr/icons'
import { formatDistanceToNowStrict } from 'date-fns'
import { computed } from 'vue'

const props = defineProps<{
  notification: Notification
}>()

const classes = computed(() => ({
  'tablet-h:hover:bg-[#FAFAFA]': props.notification.read,
  'bg-green-700/10': !props.notification.read,
}))

const isSuccess = computed(
  () => props.notification.type === NotificationType.UserVerificationSucess
)

const copy = computed(() => {
  if (isSuccess.value) {
    return 'Your identity has been verified.'
  }

  return "We couldn't verify your identity. Please try again."
})
</script>
